import React from "react";
import { useState } from "react";
import PopUpModal from "../Modal/PopUpModal";
import axios from "axios";

export default function ContactUs({ closeContact }) {
  const [show, setShow] = useState(false);
  const [contactData, setContactData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleInput = (e) => {
    e.preventDefault();

    setContactData({ ...contactData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    closeContact(false);
    try {
      console.log(contactData);
      const response = await axios.post("/contactus", contactData);
      if (response) {
        console.log(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <PopUpModal title="Contact Us" size="md" setmodalstate={setShow}>
        <form onSubmit={onSubmit}>
          <div className="mb-3">
            <input
              type="text"
              name="name"
              placeholder="Enter Your Name"
              className="form-control p-3"
              value={contactData.name}
              onChange={handleInput}
              required
            />
          </div>
          <div className="mb-3">
            <input
              type="email"
              name="email"
              placeholder="Enter Your Email"
              className="form-control p-3"
              value={contactData.email}
              onChange={handleInput}
              required
            />
          </div>
          <div className="mb-3">
            <textarea
              rows="5"
              name="message"
              className="form-control"
              placeholder="Notes"
              onChange={handleInput}
              value={contactData.message}
              required
            ></textarea>
          </div>
          <div className="mb-3">
            <button type="submit" className="btn btn-primary w-100">
              Send
            </button>
            <button
              onClick={(e) => closeContact(false)}
              className="btn btn-outline-secondary w-100 mt-2"
            >
              Close
            </button>
          </div>
        </form>
      </PopUpModal>
    </>
  );
}
